import * as Styles from './styles'

const ReveniBackground = ({ children }) => (
  <>
    <Styles.MainContainer>
      <Styles.Container>
        <Styles.ImageContainer>
          <Styles.ReveniLogo src="/logos/Reveni_logo.svg" alt="Reveni logo" />
        </Styles.ImageContainer>
      </Styles.Container>
      {children}
    </Styles.MainContainer>
    <Styles.BackgroundCircleBottom />
    <Styles.BackgroundCircleTop />
  </>
)

export default ReveniBackground
